import { useState, useEffect, useCallback } from 'react';

// Persistent "Demo tools & guided tour" preference. When enabled, the
// bottom-center "Tools" FAB and the Missing-Middle tour launcher pills
// (Take the tour / Copy demo link / demo-readiness) are shown. Off by
// default so the app stays clean for everyday users; sales/demo folks
// flip it on from Profile settings or the Home header.
const KEY = 'mc.demoToolsEnabled';
const EVENT = 'mc:demo-tools';

export function getDemoToolsEnabled() {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
}

export function setDemoToolsEnabled(value) {
  try { localStorage.setItem(KEY, value ? '1' : '0'); } catch { /* noop */ }
  try { window.dispatchEvent(new CustomEvent(EVENT, { detail: !!value })); } catch { /* noop */ }
}

export function useDemoTools() {
  const [enabled, setEnabled] = useState(getDemoToolsEnabled);

  useEffect(() => {
    const onEvent = (e) => setEnabled(!!e.detail);
    const onStorage = (e) => { if (e.key === KEY) setEnabled(e.newValue === '1'); };
    window.addEventListener(EVENT, onEvent);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener(EVENT, onEvent);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  const set = useCallback((value) => setDemoToolsEnabled(value), []);
  return [enabled, set];
}

export default useDemoTools;
